import destroy from "../destroy";
import onInit from "./listeners/events/on-init";
import initInitials from "./listeners/utils/init-initials";
import staticInit from "./static/static-init";
import reloadGlobalListeners from "./store/utils/reload-global-listeners";

/**
 * Initializes a new instance of Main.
 * @class Main
 * @namespace Main.prototype
 * @returns {MainClassProps}
 */
class Main {
  /**
   * @constructor
   * @param {TorusElement} element
   */
  constructor(element) {
    this.element = element;
    this.isMain = true;
    this.isGroup = false;
  }

  /**
   * Initialize the Main class
   * @param {Object} [options]
   */
  init(options) {}

  /**
   * Create a `store` map
   * @param {AttributesProps} attributes
   */
  createStore(attributes) {}

  /**
   * Add triggers listeners
   */
  addListeners() {}

  /**
   * Add triggers listeners
   */
  addEvents() {}

  /**
   * Initialize the Main class
   */
  processStorage() {}

  /**
   * Run the selected trigger
   */
  run() {}

  /**
   * Start the functions that compute timelines
   * @param {Number} now
   * @param {Boolean} isInitial
   */
  animate(now, isInitial) {}

  /**
   * Defaults
   */
  defaults() {}

  /**
   * ------------------------------------------------------------------------
   * Static
   * ------------------------------------------------------------------------
   */

  /**
   * Destroy method
   * @param {IterableElementsProps} elements
   */
  static destroy(elements) {
    destroy(elements);
  }

  /**
   * Main init
   * @param {Set<TorusElement> | Array<TorusElement>} elements
   * @param {Object} [options]
   * @returns {Array<MainClassProps>}
   */
  static init(elements, options) {
    /** Run functions on init */
    onInit();

    /** Initialize */
    const inits = staticInit("Main", Main, elements, options, "tor");

    /** Initialize "initial" triggers */
    initInitials(elements);

    /** Force run elements that are linked to global listeners (scroll, pointer) */
    reloadGlobalListeners();

    return inits;
  }
}

export default Main;
